import { render, staticRenderFns } from "./leftMeun.vue?vue&type=template&id=4861634c&scoped=true&"
import script from "./leftMeun.vue?vue&type=script&lang=js&"
export * from "./leftMeun.vue?vue&type=script&lang=js&"
import style0 from "./leftMeun.vue?vue&type=style&index=0&id=4861634c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861634c",
  null
  
)

export default component.exports